// extracted by mini-css-extract-plugin
export default {"menu--dark":"Menu_menu--dark__+YWTO"};